import * as actionTypes from '../action-types';

const initialState = {
  userList: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USERS:
        return {
            ...state,
            userList: action.payload
        }
    default:
      return state;
  }
};

export default userReducer;
